// RelaySettings.utils.ts
import {RelayTimeLocal} from "./RelaySettings.model";

export class RelaySettingsUtils {
  static formatTimeRange = (t: RelayTimeLocal) =>
    `${t.onHour.toString().padStart(2, "0")}:${t.onMinute
      .toString()
      .padStart(2, "0")}–${t.offHour
      .toString()
      .padStart(2, "0")}:${t.offMinute.toString().padStart(2, "0")}`;

  static formatAstronomicTime = (t?: string | null) => {
    if (!t) return "";
    if (!t.includes(":")) return "";

    const [hhRaw, mmRaw] = t.split(":");
    const hh = (hhRaw ?? "").padStart(2, "0");
    const mm = (mmRaw ?? "").padStart(2, "0");
    return `${hh}:${mm}`;
  };
}
